/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          nationality: {
            type: 'string',
            minLength: 1,
          },
          approximateOfWrkrs: {
            type: 'number',
            maximum: 100,
          },
          approximateOfSupvs: {
            type: 'number',
            maximum: 100,
          },
        },
        required: ['nationality', 'approximateOfWrkrs', 'approximateOfSupvs'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    nationalities: valueSchema,
  },
}
